import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import _typeof from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
/**
 * ============================================================
 * 国际专区演示数据（Mock Fallback）
 * ------------------------------------------------------------
 * 用途: 门户「国际专区」联调/演示阶段的前端兜底数据
 * 规则: 接口有数据的类别一律使用接口数据, 仅在接口为空时按类别补齐;
 *       字段结构与后端 /system/intl/portal/** 返回保持对齐
 * 语言: 中(zh) / 英(en) / 俄(ru) 三语, 其它语言回退英文
 * 关闭: USE_MOCK_FALLBACK 置为 false 即可完全回到接口驱动
 * 说明: 分类展示名使用演示数据自带的分类字典, 不依赖也不覆盖管理端分类配置,
 *       管理端把测试分类改名或隐藏都不会影响这里的展示
 * 创建日期: 2026-09-29（由旧版演示数据重构）
 * ============================================================
 */

// 演示数据开关 — 后端数据补齐后置为 false
export var USE_MOCK_FALLBACK = true;

// 演示数据主键起点, 与后端自增主键天然隔离
var MOCK_ID_BASE = 9000;

// 演示动态主键起点, 与演示课程错开, 避免主键互相命中
var MOCK_NEWS_ID_BASE = MOCK_ID_BASE + 100;

// 非中/英/俄语言统一回退英文
var FALLBACK_LANG = 'en';

// 演示课程分类字典 — key 与后端 categoryKey 保持一致
var MOCK_COURSE_CATEGORY_NAMES = {
  zhinengzhizao: {
    zh: '智能制造',
    en: 'Intelligent Manufacturing',
    ru: 'Интеллектуальное производство'
  },
  shuzijishu: {
    zh: '数字技术',
    en: 'Digital Technology',
    ru: 'Цифровые технологии'
  },
  xiandaifuwu: {
    zh: '现代服务',
    en: 'Modern Services',
    ru: 'Современные услуги'
  },
  jiaotongyunshu: {
    zh: '交通运输',
    en: 'Transportation',
    ru: 'Транспорт'
  },
  caijingshangmao: {
    zh: '财经商贸',
    en: 'Finance, Business and Trade',
    ru: 'Финансы, бизнес и торговля'
  },
  wenhuayishu: {
    zh: '文化艺术',
    en: 'Culture and Art',
    ru: 'Культура и искусство'
  }
};

// 演示动态分类字典 — key 与后端 categoryKey 保持一致
var MOCK_NEWS_CATEGORY_NAMES = {
  guojijiaoyu: {
    zh: '国际教育',
    en: 'International Education',
    ru: 'Международное образование'
  },
  hezuobanxue: {
    zh: '合作办学',
    en: 'Cooperative Education',
    ru: 'Совместное образование'
  },
  kechengziyuan: {
    zh: '课程资源',
    en: 'Course Resources',
    ru: 'Ресурсы курсов'
  },
  shizipeiyang: {
    zh: '师资培养',
    en: 'Teacher Training',
    ru: 'Подготовка преподавателей'
  }
};

// 官方课程/动态分类 key 列表 — 用于按类别补齐演示数据
export var OFFICIAL_COURSE_CATEGORY_KEYS = Object.keys(MOCK_COURSE_CATEGORY_NAMES);
export var OFFICIAL_NEWS_CATEGORY_KEYS = Object.keys(MOCK_NEWS_CATEGORY_NAMES);

// 课程目录模板 — 章节名按语言给出, 节数按课时等比分配
var COURSE_OUTLINE_TITLE = {
  zh: ['课程导论', '核心技术基础', '典型应用场景', '项目实训', '综合考核'],
  en: ['Course Introduction', 'Core Technology Fundamentals', 'Typical Application Scenarios', 'Project Practice', 'Comprehensive Assessment'],
  ru: ['Введение в курс', 'Основы ключевых технологий', 'Типовые сценарии применения', 'Проектная практика', 'Итоговая аттестация']
};
var COURSE_OUTLINE_LESSONS = [4, 6, 5, 6, 3];

// 课程简介多语言文本 — 供课程详情/学习页展示
var COURSE_INTRO = {
  zh: function zh(title, categoryName, hours) {
    return "".concat(title, "\u662F\u9762\u5411\u804C\u4E1A\u9662\u6821\u5B66\u4E60\u8005\u5F00\u8BBE\u7684").concat(categoryName, "\u7C7B\u56FD\u9645\u5316\u5728\u7EBF\u7CBE\u54C1\u8BFE\u7A0B\uFF0C\u5171").concat(hours, "\u8BFE\u65F6\u3002") + "\u8BFE\u7A0B\u56F4\u7ED5\u5C97\u4F4D\u5178\u578B\u5DE5\u4F5C\u4EFB\u52A1\u7EC4\u7EC7\u6559\u5B66\u5185\u5BB9\uFF0C\u6DB5\u76D6\u57FA\u7840\u7406\u8BBA\u3001\u5173\u952E\u6280\u672F\u3001\u6848\u4F8B\u5206\u6790\u4E0E\u9879\u76EE\u5B9E\u8BAD\u56DB\u4E2A\u5C42\u6B21\uFF0C" + '帮助学习者在真实任务情境中掌握核心技能，并为后续国际交流与学习提供支撑。';
  },
  en: function en(title, categoryName, hours) {
    return "".concat(title, " is an international online quality course in the field of ").concat(categoryName, ", ") + "offered to vocational college learners with ".concat(hours, " study hours. The course is organized around typical ") + 'workplace tasks and covers fundamental theory, key technologies, case analysis and project practice, ' + 'helping learners master core skills and prepare for further international exchange.';
  },
  ru: function ru(title, categoryName, hours) {
    return "".concat(title, " \u2014 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u043E\u043D\u043B\u0430\u0439\u043D-\u043A\u0443\u0440\u0441 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \xAB").concat(categoryName, "\xBB \u043E\u0431\u044A\u0451\u043C\u043E\u043C ").concat(hours, " \u0443\u0447\u0435\u0431\u043D\u044B\u0445 \u0447\u0430\u0441\u043E\u0432, ") + 'предназначенный для студентов профессиональных учебных заведений. Курс построен вокруг типовых ' + 'профессиональных задач и охватывает теорию, ключевые технологии, разбор кейсов и проектную практику.';
  }
};

// 课程难度多语言文本
var COURSE_LEVEL = {
  beginner: {
    zh: '基础',
    en: 'Beginner',
    ru: 'Начальный'
  },
  intermediate: {
    zh: '中级',
    en: 'Intermediate',
    ru: 'Средний'
  }
};

// 课程类型多语言文本
var COURSE_TYPE = {
  zh: '在线精品课程',
  en: 'Online Quality Course',
  ru: 'Лучший онлайн-курс'
};

// 中文课程名 + 英文/俄文标题, 以及主讲教师
var MOCK_COURSES = [{
  categoryKey: 'zhinengzhizao',
  hours: 24,
  level: 'beginner',
  instructor: '李老师',
  title: {
    zh: '智能制造技术基础',
    en: 'Fundamentals of Intelligent Manufacturing',
    ru: 'Основы интеллектуального производства'
  },
  desc: {
    zh: '系统讲解智能制造的基本概念、关键技术体系与典型应用场景，涵盖工业机器人、数字化产线与智能检测等模块，帮助学习者建立完整的智能制造知识框架。',
    en: 'Systematically introduces the concepts, key technologies and typical applications of intelligent manufacturing, covering industrial robots, digital production lines and smart inspection.',
    ru: 'Системно знакомит с понятиями, ключевыми технологиями и типовыми сценариями интеллектуального производства: промышленные роботы, цифровые линии и интеллектуальный контроль.'
  }
}, {
  categoryKey: 'zhinengzhizao',
  hours: 32,
  level: 'intermediate',
  instructor: '王老师',
  title: {
    zh: '工业机器人操作与编程',
    en: 'Industrial Robot Operation and Programming',
    ru: 'Эксплуатация и программирование промышленных роботов'
  },
  desc: {
    zh: '以工业机器人典型工作站为载体，讲解机器人示教编程、轨迹规划、离线仿真与安全操作规范，配套虚拟仿真与实训任务，提升岗位实操能力。',
    en: 'Based on typical industrial robot workstations, covers teach pendant programming, trajectory planning, offline simulation and safe operation, supported by simulation and practical tasks.',
    ru: 'На базе типовых роботизированных рабочих мест рассматриваются программирование, планирование траектории, офлайн-моделирование и правила безопасной эксплуатации.'
  }
}, {
  categoryKey: 'zhinengzhizao',
  hours: 28,
  level: 'intermediate',
  instructor: '张老师',
  title: {
    zh: '数字化产线集成与调试',
    en: 'Digital Production Line Integration and Commissioning',
    ru: 'Интеграция и наладка цифровых производственных линий'
  },
  desc: {
    zh: '围绕数字化产线的组成结构与集成流程，讲解设备联调、数据采集、产线监控与故障排查方法，通过完整产线项目案例训练工程实施能力。',
    en: 'Focuses on the structure and integration process of digital production lines, covering equipment commissioning, data acquisition, monitoring and troubleshooting through complete project cases.',
    ru: 'Посвящён составу и процессу интеграции цифровых линий: наладка оборудования, сбор данных, мониторинг и диагностика неисправностей на примерах реальных проектов.'
  }
}, {
  categoryKey: 'shuzijishu',
  hours: 28,
  level: 'intermediate',
  instructor: '赵老师',
  title: {
    zh: '数字媒体技术应用',
    en: 'Digital Media Technology and Applications',
    ru: 'Применение технологий цифровых медиа'
  },
  desc: {
    zh: '介绍数字图像、音视频处理与交互媒体设计的基础方法，结合真实项目讲解素材采集、后期制作与多终端适配，培养数字内容制作与传播能力。',
    en: 'Introduces digital image, audio and video processing and interactive media design, covering asset collection, post-production and multi-device adaptation through real projects.',
    ru: 'Знакомит с обработкой цифровых изображений, аудио и видео, а также с проектированием интерактивных медиа, включая подготовку материалов и постобработку.'
  }
}, {
  categoryKey: 'shuzijishu',
  hours: 30,
  level: 'beginner',
  instructor: '陈老师',
  title: {
    zh: '大数据技术基础',
    en: 'Fundamentals of Big Data Technology',
    ru: 'Основы технологий больших данных'
  },
  desc: {
    zh: '讲解大数据技术体系的基本概念与主流工具，涵盖数据采集、存储、清洗、分析与可视化等环节，帮助学习者理解数据驱动的业务决策过程。',
    en: 'Explains the concepts and mainstream tools of big data, covering data collection, storage, cleaning, analysis and visualization, and how data drives business decisions.',
    ru: 'Излагает понятия и основные инструменты больших данных: сбор, хранение, очистка, анализ и визуализация данных, а также принятие решений на основе данных.'
  }
}, {
  categoryKey: 'xiandaifuwu',
  hours: 20,
  level: 'beginner',
  instructor: '孙老师',
  title: {
    zh: '现代服务礼仪',
    en: 'Modern Service Etiquette',
    ru: 'Этикет современного сервиса'
  },
  desc: {
    zh: '面向现代服务行业岗位需求，系统讲解仪容仪表、沟通表达、接待流程与投诉处理规范，通过情境演练提升服务意识与职业素养。',
    en: 'Addresses the needs of modern service positions, covering appearance, communication, reception procedures and complaint handling, improving service awareness through scenario practice.',
    ru: 'Ориентирован на требования сферы услуг: внешний вид, коммуникация, приём гостей и работа с жалобами, а также развитие сервисных навыков.'
  }
}, {
  categoryKey: 'xiandaifuwu',
  hours: 24,
  level: 'intermediate',
  instructor: '周老师',
  title: {
    zh: '智慧健康养老服务',
    en: 'Smart Health and Elderly Care Services',
    ru: 'Умные услуги здравоохранения и ухода за пожилыми'
  },
  desc: {
    zh: '结合智慧养老行业发展趋势，讲解健康监测、康复辅助、生活照护与心理支持等核心服务内容，并介绍智能设备在养老服务中的应用。',
    en: 'Combines industry trends in smart elderly care with health monitoring, rehabilitation assistance, daily care and psychological support, and the use of smart devices in care services.',
    ru: 'Сочетает тенденции умного ухода за пожилыми с мониторингом здоровья, реабилитацией, бытовым уходом и психологической поддержкой, включая применение умных устройств.'
  }
}, {
  categoryKey: 'jiaotongyunshu',
  hours: 30,
  level: 'intermediate',
  instructor: '刘老师',
  title: {
    zh: '城市轨道交通运营管理',
    en: 'Urban Rail Transit Operations and Management',
    ru: 'Управление эксплуатацией городского рельсового транспорта'
  },
  desc: {
    zh: '系统介绍城市轨道交通行车组织、客运服务、设备维护与应急处置等运营管理内容，结合调度案例训练岗位综合能力。',
    en: 'Introduces train operation organization, passenger services, equipment maintenance and emergency response in urban rail transit, with dispatching cases to build job competence.',
    ru: 'Знакомит с организацией движения, обслуживанием пассажиров, обслуживанием оборудования и действиями в чрезвычайных ситуациях, включая диспетчерские кейсы.'
  }
}, {
  categoryKey: 'jiaotongyunshu',
  hours: 26,
  level: 'beginner',
  instructor: '吴老师',
  title: {
    zh: '智能网联汽车技术基础',
    en: 'Fundamentals of Intelligent Connected Vehicle Technology',
    ru: 'Основы технологий интеллектуальных подключённых автомобилей'
  },
  desc: {
    zh: '讲解智能网联汽车的环境感知、车联网通信、智能决策与线控底盘等关键技术，帮助学习者建立对智能汽车技术体系的整体认识。',
    en: 'Explains environmental perception, V2X communication, intelligent decision-making and drive-by-wire chassis, giving learners an overall understanding of intelligent vehicle technology.',
    ru: 'Рассматривает восприятие окружения, связь V2X, интеллектуальное принятие решений и шасси с электронным управлением, формируя целостное представление о технологиях.'
  }
}, {
  categoryKey: 'caijingshangmao',
  hours: 28,
  level: 'intermediate',
  instructor: '郑老师',
  title: {
    zh: '跨境电子商务实务',
    en: 'Cross-Border E-Commerce Practice',
    ru: 'Практика трансграничной электронной коммерции'
  },
  desc: {
    zh: '围绕跨境电商业务流程，讲解选品分析、店铺运营、国际物流、跨境支付与合规风控等实务内容，配合真实平台案例开展操作训练。',
    en: 'Follows the cross-border e-commerce workflow, covering product selection, store operations, international logistics, cross-border payment and compliance risk control.',
    ru: 'Построен вокруг бизнес-процессов трансграничной торговли: подбор товаров, управление магазином, логистика, платежи и контроль соответствия требованиям.'
  }
}, {
  categoryKey: 'caijingshangmao',
  hours: 26,
  level: 'beginner',
  instructor: '冯老师',
  title: {
    zh: '国际商务基础',
    en: 'Fundamentals of International Business',
    ru: 'Основы международного бизнеса'
  },
  desc: {
    zh: '介绍国际贸易惯例、商务谈判、单证处理与跨文化沟通等基础知识，帮助学习者理解国际商务活动的完整链条与基本规范。',
    en: 'Introduces international trade practices, business negotiation, documentation and cross-cultural communication, helping learners understand the full chain of international business.',
    ru: 'Знакомит с международной торговой практикой, деловыми переговорами, документацией и кросс-культурной коммуникацией в международном бизнесе.'
  }
}, {
  categoryKey: 'wenhuayishu',
  hours: 24,
  level: 'beginner',
  instructor: '许老师',
  title: {
    zh: '中国传统工艺与数字文创',
    en: 'Chinese Traditional Crafts and Digital Cultural Creativity',
    ru: 'Китайские традиционные ремёсла и цифровое культурное творчество'
  },
  desc: {
    zh: '以中国传统工艺为载体，讲解纹样提取、数字化建模与文创产品设计方法，引导学习者在传承传统文化的基础上开展创意设计实践。',
    en: 'Uses traditional Chinese crafts as a carrier to teach pattern extraction, digital modeling and cultural product design, encouraging creative practice on the basis of cultural heritage.',
    ru: 'На основе традиционных ремёсел рассматриваются извлечение орнаментов, цифровое моделирование и дизайн культурной продукции, развивая творческую практику.'
  }
}, {
  categoryKey: 'wenhuayishu',
  hours: 22,
  level: 'intermediate',
  instructor: '何老师',
  title: {
    zh: '国际艺术设计基础',
    en: 'Fundamentals of International Art and Design',
    ru: 'Основы международного искусства и дизайна'
  },
  desc: {
    zh: '讲解设计构成、色彩原理、版式编排与视觉表达的基本方法，并通过国际设计案例赏析提升学习者的审美素养与设计表达能力。',
    en: 'Covers design composition, color principles, layout and visual expression, and improves aesthetic literacy and design expression through international design case studies.',
    ru: 'Рассматривает композицию, цветовые принципы, вёрстку и визуальное выражение, развивая эстетический вкус и навыки дизайна на международных примерах.'
  }
}, {
  categoryKey: 'zhinengzhizao',
  hours: 20,
  level: 'beginner',
  instructor: '北京职业教育国际化教学团队',
  title: {
    zh: '国际智能制造基础课程',
    en: 'International Intelligent Manufacturing Fundamentals',
    ru: 'Международный курс основ интеллектуального производства'
  },
  desc: {
    zh: '面向国际交流场景开设的智能制造入门课程，介绍智能制造的发展脉络、技术框架与国际典型实践，为跨校学习与交流提供共同知识基础。',
    en: 'An introductory intelligent manufacturing course for international exchange, introducing its development, technical framework and international practices as a shared knowledge base.',
    ru: 'Вводный курс по интеллектуальному производству для международного обмена: история развития, техническая структура и зарубежная практика.'
  }
}, {
  categoryKey: 'zhinengzhizao',
  hours: 18,
  level: 'beginner',
  instructor: '北京职业教育国际化教学团队',
  title: {
    zh: '智能制造导论',
    en: 'Introduction to Intelligent Manufacturing',
    ru: 'Введение в интеллектуальное производство'
  },
  desc: {
    zh: '从产业发展视角梳理智能制造的由来、内涵与关键支撑技术，帮助学习者快速建立对智能制造领域的整体认知。',
    en: 'Reviews the origin, connotation and key supporting technologies of intelligent manufacturing from an industry perspective, building overall understanding quickly.',
    ru: 'С позиции отрасли рассматривает происхождение, содержание и ключевые технологии интеллектуального производства, формируя целостное представление.'
  }
}, {
  categoryKey: 'zhinengzhizao',
  hours: 24,
  level: 'intermediate',
  instructor: '北京职业教育国际化教学团队',
  title: {
    zh: '智能制造项目实训',
    en: 'Intelligent Manufacturing Project Practice',
    ru: 'Проектная практика интеллектуального производства'
  },
  desc: {
    zh: '以完整项目任务驱动教学，围绕方案设计、设备调试、数据采集与成果交付展开实训，训练学习者解决真实工程问题的综合能力。',
    en: 'Driven by a complete project task, covering solution design, equipment commissioning, data acquisition and delivery, training the ability to solve real engineering problems.',
    ru: 'Обучение на основе комплексного проекта: проектирование, наладка оборудования, сбор данных и сдача результатов, развитие навыков решения реальных задач.'
  }
}, {
  categoryKey: 'shuzijishu',
  hours: 26,
  level: 'beginner',
  instructor: '杨老师',
  title: {
    zh: '网络安全基础与应用',
    en: 'Fundamentals and Applications of Cybersecurity',
    ru: 'Основы и применение кибербезопасности'
  },
  desc: {
    zh: '围绕网络安全岗位需求，讲解网络攻防基础、常见安全威胁与防护策略、数据安全与合规要求，并通过实训环境开展安全配置与应急处置演练。',
    en: 'Addresses cybersecurity job requirements, covering attack and defense fundamentals, common threats and protection strategies, data security and compliance, with hands-on practice.',
    ru: 'Ориентирован на требования профессии: основы защиты и атак, типовые угрозы и меры защиты, безопасность данных и соответствие требованиям, с практическими занятиями.'
  }
}, {
  categoryKey: 'shuzijishu',
  hours: 24,
  level: 'intermediate',
  instructor: '黄老师',
  title: {
    zh: '云计算平台运维',
    en: 'Cloud Computing Platform Operations and Maintenance',
    ru: 'Эксплуатация облачных платформ'
  },
  desc: {
    zh: '讲解云计算基础架构、虚拟化技术、云平台部署与日常运维方法，结合典型故障案例训练学习者的平台管理与问题排查能力。',
    en: 'Covers cloud infrastructure, virtualization, platform deployment and daily operations, building platform management and troubleshooting skills through typical failure cases.',
    ru: 'Рассматривает облачную инфраструктуру, виртуализацию, развёртывание и повседневную эксплуатацию платформ, развивая навыки диагностики на типовых сбоях.'
  }
}, {
  categoryKey: 'xiandaifuwu',
  hours: 22,
  level: 'beginner',
  instructor: '马老师',
  title: {
    zh: '现代物流服务与管理',
    en: 'Modern Logistics Services and Management',
    ru: 'Современная логистика и управление'
  },
  desc: {
    zh: '介绍现代物流的基本流程与作业规范，涵盖仓储管理、配送组织、物流信息技术与客户服务等内容，配套仓储与配送情境实训。',
    en: 'Introduces logistics processes and operating standards, covering warehousing, distribution, logistics information technology and customer service, with scenario practice.',
    ru: 'Знакомит с процессами и нормативами логистики: складское хозяйство, доставка, информационные технологии и обслуживание клиентов, с практическими заданиями.'
  }
}, {
  categoryKey: 'jiaotongyunshu',
  hours: 28,
  level: 'beginner',
  instructor: '朱老师',
  title: {
    zh: '新能源汽车检测与维修',
    en: 'New Energy Vehicle Inspection and Maintenance',
    ru: 'Диагностика и обслуживание электромобилей'
  },
  desc: {
    zh: '围绕新能源汽车结构与工作原理，讲解动力电池、驱动电机与整车控制系统的检测方法，并开展规范化维修与安全操作实训。',
    en: 'Based on the structure and principles of new energy vehicles, covers testing of power batteries, drive motors and vehicle control systems, with standardized maintenance practice.',
    ru: 'На основе устройства электромобилей рассматриваются методы диагностики тяговых батарей, электродвигателей и систем управления, а также безопасное обслуживание.'
  }
}, {
  categoryKey: 'caijingshangmao',
  hours: 24,
  level: 'intermediate',
  instructor: '秦老师',
  title: {
    zh: '跨境电商视觉营销',
    en: 'Visual Marketing for Cross-Border E-Commerce',
    ru: 'Визуальный маркетинг в трансграничной торговле'
  },
  desc: {
    zh: '聚焦跨境电商平台的视觉呈现规律，讲解商品拍摄、主图设计、详情页排版与营销文案撰写方法，提升店铺转化与品牌表达能力。',
    en: 'Focuses on visual presentation in cross-border e-commerce, covering product photography, main image design, detail page layout and marketing copywriting to improve conversion.',
    ru: 'Посвящён визуальному оформлению в трансграничной торговле: съёмка товаров, главные изображения, вёрстка карточек и маркетинговые тексты для роста конверсии.'
  }
}, {
  categoryKey: 'wenhuayishu',
  hours: 20,
  level: 'beginner',
  instructor: '曹老师',
  title: {
    zh: '数字影视后期制作',
    en: 'Digital Film and Television Post-Production',
    ru: 'Цифровая постобработка кино и телевидения'
  },
  desc: {
    zh: '讲解数字剪辑、调色、特效合成与音频处理的基本流程，通过短片项目训练学习者完成从素材整理到成片输出的完整后期制作能力。',
    en: 'Covers editing, color grading, visual effects compositing and audio processing, training learners to complete a full post-production workflow through short film projects.',
    ru: 'Рассматривает монтаж, цветокоррекцию, композитинг и обработку звука, развивая навыки полного цикла постобработки на примере короткометражных проектов.'
  }
}];

// 动态标题与摘要多语言文本
var MOCK_NEWS = [{
  categoryKey: 'guojijiaoyu',
  title: {
    zh: '北京职业院校与海外院校启动新一期师生交流项目',
    en: 'Beijing Vocational Colleges Launch a New Round of Faculty and Student Exchange',
    ru: 'Новый этап программы обмена студентов и преподавателей'
  },
  summary: {
    zh: '双方围绕专业共建、课程共享与师生互访达成合作意向，首批交流项目将于本学年内陆续启动。',
    en: 'Both sides reached cooperation intentions on program co-construction, course sharing and mutual visits, with the first projects starting this academic year.',
    ru: 'Стороны договорились о совместной разработке программ, обмене курсами и взаимных визитах; первые проекты стартуют в этом учебном году.'
  }
}, {
  categoryKey: 'guojijiaoyu',
  title: {
    zh: '国际理解教育课程在北京市职业院校上线',
    en: 'International Understanding Courses Launched in Beijing Vocational Colleges',
    ru: 'В пекинских колледжах запущены курсы международного взаимопонимания'
  },
  summary: {
    zh: '课程以跨文化交流与全球视野培养为目标，采用中英双语教学，已在多所职业院校投入使用。',
    en: 'Aimed at cross-cultural communication and global vision, the courses are taught bilingually and have been adopted by several vocational colleges.',
    ru: 'Курсы направлены на кросс-культурную коммуникацию и формирование глобального кругозора, преподаются на двух языках и уже внедрены в колледжах.'
  }
}, {
  categoryKey: 'hezuobanxue',
  title: {
    zh: '中外合作办学项目教学质量检查顺利完成',
    en: 'Teaching Quality Review of Sino-Foreign Cooperative Programs Completed',
    ru: 'Завершена проверка качества совместных образовательных программ'
  },
  summary: {
    zh: '检查组对合作项目的课程实施、师资配备与学生发展情况进行评估，整体运行规范有序。',
    en: 'The review covered curriculum implementation, faculty allocation and student development, and the programs were found to be well organized.',
    ru: 'Проверены реализация программ, состав преподавателей и развитие студентов; отмечена упорядоченная организация обучения.'
  }
}, {
  categoryKey: 'hezuobanxue',
  title: {
    zh: '海外实训基地共建项目进入实施阶段',
    en: 'Overseas Training Base Co-construction Project Enters Implementation',
    ru: 'Проект совместного создания зарубежной базы практики перешёл к реализации'
  },
  summary: {
    zh: '项目将依托合作院校实训条件，为学生提供跨境实训与岗位实践机会，首批学生计划年内派出。',
    en: 'Relying on partner institutions, the project offers cross-border training and internship opportunities, with the first students expected to go abroad this year.',
    ru: 'Проект предоставит студентам возможности зарубежной практики на базе партнёрских учебных заведений; первая группа планируется в этом году.'
  }
}, {
  categoryKey: 'kechengziyuan',
  title: {
    zh: '首批多语种国际化课程标准完成开发',
    en: 'First Batch of Multilingual International Course Standards Completed',
    ru: 'Завершена разработка первых многоязычных международных стандартов курсов'
  },
  summary: {
    zh: '课程标准覆盖智能制造、数字技术等重点领域，支持中英俄多语种呈现，为资源共建提供统一依据。',
    en: 'The standards cover key fields such as intelligent manufacturing and digital technology, support Chinese, English and Russian, and provide a unified basis for co-development.',
    ru: 'Стандарты охватывают интеллектуальное производство и цифровые технологии, поддерживают китайский, английский и русский языки и служат единой основой.'
  }
}, {
  categoryKey: 'kechengziyuan',
  title: {
    zh: '国际化在线精品课程资源库正式发布',
    en: 'International Online Quality Course Resource Library Released',
    ru: 'Опубликована библиотека международных онлайн-курсов'
  },
  summary: {
    zh: '资源库汇聚多所职业院校优质课程，支持按专业类别与语种检索，为国际化教学提供共享资源支撑。',
    en: 'The library gathers quality courses from multiple colleges and supports retrieval by program category and language, providing shared resources for international teaching.',
    ru: 'Библиотека объединяет качественные курсы нескольких колледжей, поддерживает поиск по направлениям и языкам и обеспечивает общий доступ к ресурсам.'
  }
}, {
  categoryKey: 'shizipeiyang',
  title: {
    zh: '国际化师资研修计划启动',
    en: 'International Faculty Development Program Launched',
    ru: 'Запущена программа развития международных преподавателей'
  },
  summary: {
    zh: '研修围绕国际化课程开发、课堂教学评价与数字化教学工具应用组织专题学习，首批教师已完成开班。',
    en: 'The program focuses on international course development, classroom evaluation and digital teaching tools; the first group of teachers has started training.',
    ru: 'Программа посвящена разработке международных курсов, оценке занятий и цифровым инструментам обучения; первая группа преподавателей уже начала обучение.'
  }
}, {
  categoryKey: 'shizipeiyang',
  title: {
    zh: '职业院校教师双语教学能力提升培训开班',
    en: 'Bilingual Teaching Competence Training for Vocational Teachers Opens',
    ru: 'Стартовало обучение преподавателей колледжей двуязычному преподаванию'
  },
  summary: {
    zh: '培训聚焦双语课堂组织与专业外语表达，通过示范课与工作坊形式提升教师国际化教学能力。',
    en: 'The training focuses on bilingual classroom organization and professional language expression, improving international teaching competence through demo classes and workshops.',
    ru: 'Обучение посвящено организации двуязычных занятий и профессиональной лексике; навыки развиваются через показательные занятия и мастерские.'
  }
}];

// 演示动态正文 — 按语言拼装标准段落
var NEWS_CONTENT = {
  zh: function zh(title, summary) {
    return "<p>".concat(summary, "</p><p>\u5317\u4EAC\u5E02\u804C\u4E1A\u6559\u80B2\u56FD\u9645\u5316\u5C55\u793A\u5E73\u53F0\u6301\u7EED\u6C47\u805A\u804C\u4E1A\u9662\u6821\u5728\u56FD\u9645\u4EA4\u6D41\u3001\u5408\u4F5C\u529E\u5B66\u3001\u8BFE\u7A0B\u8D44\u6E90\u5EFA\u8BBE\u4E0E\u5E08\u8D44\u57F9\u517B\u7B49\u65B9\u9762\u7684\u6700\u65B0\u8FDB\u5C55\uFF0C") + "\u4E3A\u9662\u6821\u3001\u5E08\u751F\u53CA\u56FD\u9645\u5408\u4F5C\u4F19\u4F34\u63D0\u4F9B\u7EDF\u4E00\u7684\u4FE1\u606F\u7A97\u53E3\u3002</p><p>\u672C\u6761\u4E3A\u300C".concat(title, "\u300D\u7684\u6F14\u793A\u5185\u5BB9\uFF0C\u7528\u4E8E\u8054\u8C03\u4E0E\u6F14\u793A\u9636\u6BB5\u5C55\u793A\u9875\u9762\u6548\u679C\uFF0C\u540E\u7AEF\u6570\u636E\u8865\u9F50\u540E\u53EF\u7531\u6B63\u5F0F\u5185\u5BB9\u66FF\u6362\u3002</p>");
  },
  en: function en(title, summary) {
    return "<p>".concat(summary, "</p><p>The Beijing International Vocational Education showcase platform continues to gather the latest progress of ") + 'vocational colleges in international exchange, cooperative education, course resource development and faculty training.</p>' + "<p>This is demo content for \"".concat(title, "\", used to present page effects during integration and demonstration.</p>");
  },
  ru: function ru(title, summary) {
    return "<p>".concat(summary, "</p><p>\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0439 \u0432\u0438\u0442\u0440\u0438\u043D\u044B \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0435\u043A\u0438\u043D\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0435\u0442 \u0441\u043E\u0431\u0438\u0440\u0430\u0442\u044C \u0441\u0432\u0435\u0436\u0438\u0435 ") + 'материалы о международном обмене, совместном обучении, разработке курсов и подготовке преподавателей.</p>' + "<p>\u042D\u0442\u043E \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B \u0434\u043B\u044F \xAB".concat(title, "\xBB, \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u0434\u043B\u044F \u043F\u043E\u043A\u0430\u0437\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043D\u0430 \u044D\u0442\u0430\u043F\u0435 \u043E\u0442\u043B\u0430\u0434\u043A\u0438.</p>");
  }
};

// 当前语言归一化 — 仅支持 zh/en/ru, 其它语言回退英文
function normalizeLang(lang) {
  return lang === 'zh' || lang === 'en' || lang === 'ru' ? lang : FALLBACK_LANG;
}

// 取多语言字段, 缺失时依次回退英文、中文
function pickLang(value, lang) {
  if (value === null || value === undefined) return '';
  if (_typeof(value) !== 'object') return value;
  return value[lang] || value[FALLBACK_LANG] || value.zh || '';
}

// 构造课程目录 — 章节名按语言给出, 节数按课时等比分配
function buildOutline(lang, hours) {
  var titles = COURSE_OUTLINE_TITLE[lang] || COURSE_OUTLINE_TITLE[FALLBACK_LANG];
  return titles.map(function (title, index) {
    return {
      id: index + 1,
      title: title,
      parentId: 0,
      content: '',
      resourceUrl: '',
      lessons: COURSE_OUTLINE_LESSONS[index]
    };
  });
}

// 演示课程 -> 后端课程组结构（course + selectedVersion + supportedLanguages）
function buildMockCourseGroup(source, lang) {
  var categoryName = pickLang(MOCK_COURSE_CATEGORY_NAMES[source.categoryKey], lang);
  var title = pickLang(source.title, lang);
  var hours = source.hours;
  var selectedVersion = {
    language: lang,
    title: title,
    description: pickLang(source.desc, lang),
    courseUrl: null,
    sourceName: pickLang(COURSE_TYPE, lang),
    level: pickLang(COURSE_LEVEL[source.level], lang),
    studyHours: hours,
    publishStatus: '1',
    auditStatus: 'approved',
    teacherName: source.instructor,
    chapters: buildOutline(lang, hours)
  };
  return {
    selectedLanguage: lang,
    supportedLanguages: ['zh', 'en', 'ru'],
    category: source.categoryKey,
    categoryKey: source.categoryKey,
    categoryName: categoryName,
    course: {
      id: source.mockId,
      categoryKey: source.categoryKey,
      categoryName: categoryName,
      coverUrl: '',
      defaultLang: 'zh',
      teacherName: source.instructor,
      supportedLanguages: 'zh,en,ru'
    },
    selectedVersion: selectedVersion
  };
}

// 演示课程 -> 门户课程列表结构（对齐 IntlCourseVO）
function buildMockCourseRow(source, lang) {
  var categoryName = pickLang(MOCK_COURSE_CATEGORY_NAMES[source.categoryKey], lang);
  return {
    id: source.mockId,
    categoryKey: source.categoryKey,
    category: source.categoryKey,
    categoryName: categoryName,
    coverUrl: '',
    defaultLang: 'zh',
    supportedLanguages: 'zh,en,ru',
    language: lang,
    title: pickLang(source.title, lang),
    description: pickLang(source.desc, lang),
    courseUrl: null,
    sourceName: pickLang(COURSE_TYPE, lang),
    level: pickLang(COURSE_LEVEL[source.level], lang),
    studyHours: source.hours,
    teacherName: source.instructor,
    publishStatus: '1',
    auditStatus: 'approved',
    displayStatus: '1'
  };
}

// 演示动态 -> 门户动态结构（对齐 IntlNews）
function buildMockNewsRow(source, lang, index) {
  var categoryName = pickLang(MOCK_NEWS_CATEGORY_NAMES[source.categoryKey], lang);
  var title = pickLang(source.title, lang);
  var summary = pickLang(source.summary, lang);
  return {
    id: MOCK_NEWS_ID_BASE + index + 1,
    categoryKey: source.categoryKey,
    category: source.categoryKey,
    categoryName: categoryName,
    title: title,
    summary: summary,
    content: (NEWS_CONTENT[lang] || NEWS_CONTENT[FALLBACK_LANG])(title, summary),
    source: '北京市职业教育国际化展示',
    publishTime: '2026-09-20 09:00:00',
    coverUrl: '',
    isFeature: index === 0 ? 1 : 0,
    publishStatus: '1',
    language: lang
  };
}

// 为课程补齐 mockId — 模块加载时统一分配, 保证 id 稳定
MOCK_COURSES.forEach(function (item, index) {
  item.mockId = MOCK_ID_BASE + index + 1;
  item.id = item.mockId;
});

// === 供 API 层调用的取数方法 ===

/** 演示课程原始数据 */
export function getMockCourses() {
  return MOCK_COURSES;
}

/** 按类别取演示课程（返回列表结构） */
export function getMockCourseRows(categoryKey, lang) {
  var currentLang = normalizeLang(lang);
  return MOCK_COURSES.filter(function (item) {
    return !categoryKey || item.categoryKey === categoryKey;
  }).map(function (item) {
    return buildMockCourseRow(item, currentLang);
  });
}

/** 按类别取演示动态（返回列表结构） */
export function getMockNewsRows(categoryKey, lang) {
  var currentLang = normalizeLang(lang);
  return MOCK_NEWS.map(function (item, index) {
    return buildMockNewsRow(item, currentLang, index);
  }).filter(function (item) {
    return !categoryKey || item.categoryKey === categoryKey;
  });
}

/** 演示课程详情 — 对齐 /course/group/{id} 返回结构 */
export function getMockCourseGroup(id, lang) {
  var currentLang = normalizeLang(lang);
  var source = MOCK_COURSES.find(function (item) {
    return String(item.mockId) === String(id);
  });
  if (!source) return null;
  return buildMockCourseGroup(source, currentLang);
}

/** 演示动态详情 */
export function getMockNewsDetail(id, lang) {
  var currentLang = normalizeLang(lang);
  var index = MOCK_NEWS.findIndex(function (item, i) {
    return String(MOCK_NEWS_ID_BASE + i + 1) === String(id);
  });
  if (index < 0) return null;
  return buildMockNewsRow(MOCK_NEWS[index], currentLang, index);
}

/** 判断是否为演示数据主键 */
export function isMockId(id) {
  return Number(id) >= MOCK_ID_BASE;
}